// sidebarConstants.js - Part 1: Imports and Icon Definitions
import { USER_ROLES } from './authConstants';

// =============================================================================
// MENU ITEM ICONS
// =============================================================================

const DashboardIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2v1a1 1 0 011-1h14a1 1 0 011 1v1M3 7l9 6 9-6" 
    />
  </svg>
);

const ProjectIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h4.125M8.25 8.25l2.25 2.25-2.25 2.25M13.5 8.25l2.25 2.25-2.25 2.25" 
    />
  </svg>
);

const DocumentIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
    />
  </svg>
);

const OngoingIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" 
    />
  </svg>
);

const SessionIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" 
    />
  </svg>
);

const DepartmentIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" 
    />
  </svg>
);

const SchemesIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" 
    />
  </svg>
);

const AllocationIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" 
    />
  </svg>
);

const DonerIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" 
    />
  </svg>
);

const NecIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M13 10V3L4 14h7v7l9-11h-7z" 
    />
  </svg>
);

const StateIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" 
    />
  </svg>
);

const InstallmentIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
    />
  </svg>
);

const UcIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" 
    />
  </svg>
);

const OverallIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} 
      d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" 
    />
  </svg>
);

// =============================================================================
// BUDGET TAB MENU ITEMS
// =============================================================================


export const BUDGET_MENU_ITEMS = {
  DASHBOARD: {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: <DashboardIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'single'
  },

  PROJECT_PLANNING: {
    id: 'project-planning',
    label: 'Project Proposals',
    icon: <ProjectIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'planning-form', 
        label: 'New Project Proposal', 
        path: '/budget/projects-planning',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT]
      },
      { 
        id: 'project-history', 
        label: 'Project Proposal Status', 
        path: '/budget/projects-history',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      },
      { 
        id: 'department-submissions', 
        label: 'Submitted Documents', 
        path: '/budget/department-submissions',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <DocumentIcon />
      },
      { 
        id: 'project-approval', 
        label: 'Project Approval', 
        path: '/budget/projects-approval',
        allowedRoles: [USER_ROLES.ADMIN]
      }
    ]
  },

  ONGOING_PROJECTS: {
    id: 'ongoing-projects',
    label: 'Ongoing Projects',
    icon: <OngoingIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'ongoing-projects-form', 
        label: 'Ongoing Projects', 
        path: '/budget/ongoing-projects',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT]
      },
      { 
        id: 'ongoing-projects-display', 
        label: 'Ongoing Projects Overview', 
        path: '/budget/ongoing-projects-display',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      }
    ]
  },

  SESSION_BUDGET: {
    id: 'session-budget',
    label: 'Sectoral Outlay',
    icon: <SessionIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'session-budget', 
        label: 'Department Wise', 
        path: '/budget/session-budget',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      },
      { 
        id: 'session-descriptive', 
        label: 'Project Wise', 
        path: '/budget/session-descriptive',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DEPARTMENT, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      }
    ]
  },

  DEPARTMENTS: {
    id: 'state-departments',
    label: (
      <span>
        State Share Allocation<br />
        <span className="text-xs">(50%)</span>
      </span>
    ),
    path: '/budget/departments',
    icon: <DepartmentIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'single'
  },
};

// =============================================================================
// STATE TAB MENU ITEMS
// =============================================================================

export const STATE_MENU_ITEMS = {
  SECTORAL_OUTLAY: {
    id: 'sectoral-outlay',
    label: 'Sectoral Outlay',
    icon: <SchemesIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'department-wise-allocation', 
        label: 'Department Wise', 
        path: '/state/department-wise-allocation',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      },
      { 
        id: 'project-wise', 
        label: 'Project Wise', 
        path: '/state/project-wise',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      }
    ]
  },

  ALLOCATION: {
    id: 'state-allocation',
    label: 'State Share',
    icon: <AllocationIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'departmental-allocation', 
        label: 'Department Wise', 
        path: '/state/departmental-allocation',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      },
      { 
        id: 'project-allocation', 
        label: 'Project Wise', 
        path: '/state/project-allocation',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER]
      }
    ]
  }
};

// =============================================================================
// CENTRAL TAB MENU ITEMS
// =============================================================================

export const CENTRAL_MENU_ITEMS = {
  NEW_PROJECT: {
    id: 'central-new-project',
    label: 'New Project',
    icon: <ProjectIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'new-project-doner', 
        label: 'DoNER', 
        path: '/central/doner',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <DonerIcon />
      },
      { 
        id: 'new-project-nec', 
        label: 'NEC', 
        path: '/central/nec',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <NecIcon />
      }
    ]
  },

  INSTALLMENT: {
    id: 'central-installment',
    label: 'Installment',
    icon: <InstallmentIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'installment-doner', 
        label: 'DoNER', 
        path: '/central/installment/doner',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <DonerIcon />
      },
      { 
        id: 'installment-nec', 
        label: 'NEC', 
        path: '/central/installment/nec',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <NecIcon />
      },
      { 
        id: 'installment-state', 
        label: 'State', 
        path: '/central/installment/state',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <StateIcon />
      }
    ]
  },

  OVERALL: {
    id: 'central-overall',
    label: 'Overall',
    path: '/central/overall',
    icon: <OverallIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'single'
  },

  UTILIZATION_CERTIFICATE: {
    id: 'central-uc',
    label: 'Utilization Certificate',
    icon: <UcIcon />,
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
    type: 'group',
    items: [
      { 
        id: 'uc-doner', 
        label: 'DoNER', 
        path: '/central/uc/doner',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <DonerIcon />
      },
      { 
        id: 'uc-nec', 
        label: 'NEC', 
        path: '/central/uc/nec',
        allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.PLANNING_OFFICIAL, USER_ROLES.DONER],
        icon: <NecIcon />
      }
    ]
  }
};

// =============================================================================
// ROLE-BASED SIDEBAR CONFIGURATIONS
// =============================================================================

export const ROLE_SIDEBAR_CONFIG = {
  [USER_ROLES.ADMIN]: {
    budget: [
      BUDGET_MENU_ITEMS.DASHBOARD,
      BUDGET_MENU_ITEMS.PROJECT_PLANNING,
      BUDGET_MENU_ITEMS.ONGOING_PROJECTS,
      BUDGET_MENU_ITEMS.SESSION_BUDGET,
      BUDGET_MENU_ITEMS.DEPARTMENTS
    ],
    state: [
      STATE_MENU_ITEMS.SECTORAL_OUTLAY,
      STATE_MENU_ITEMS.ALLOCATION
    ],
    central: [
      CENTRAL_MENU_ITEMS.NEW_PROJECT,
      CENTRAL_MENU_ITEMS.INSTALLMENT,
      CENTRAL_MENU_ITEMS.UTILIZATION_CERTIFICATE,
      CENTRAL_MENU_ITEMS.OVERALL
    ],
    defaultExpanded: []
  },

  [USER_ROLES.PLANNING_OFFICIAL]: {
    budget: [
      BUDGET_MENU_ITEMS.DASHBOARD,
      BUDGET_MENU_ITEMS.PROJECT_PLANNING, // Will show only "Project Proposal Status"
      BUDGET_MENU_ITEMS.ONGOING_PROJECTS, // Will show only "Ongoing Projects Overview"
      BUDGET_MENU_ITEMS.SESSION_BUDGET,
      BUDGET_MENU_ITEMS.DEPARTMENTS
    ],
    state: [
      STATE_MENU_ITEMS.SECTORAL_OUTLAY,
      STATE_MENU_ITEMS.ALLOCATION
    ],
    central: [
      CENTRAL_MENU_ITEMS.NEW_PROJECT,
      CENTRAL_MENU_ITEMS.INSTALLMENT,
      CENTRAL_MENU_ITEMS.UTILIZATION_CERTIFICATE,
      CENTRAL_MENU_ITEMS.OVERALL
    ],
    defaultExpanded: []
  },

  [USER_ROLES.DONER]: {
    budget: [
      BUDGET_MENU_ITEMS.DASHBOARD,
      BUDGET_MENU_ITEMS.PROJECT_PLANNING, // Excludes "New Project Proposal"
      BUDGET_MENU_ITEMS.ONGOING_PROJECTS, // Will show only "Ongoing Projects Overview"
      BUDGET_MENU_ITEMS.SESSION_BUDGET,
      BUDGET_MENU_ITEMS.DEPARTMENTS
    ],
    state: [
      STATE_MENU_ITEMS.SECTORAL_OUTLAY,
      STATE_MENU_ITEMS.ALLOCATION
    ],
    central: [
      CENTRAL_MENU_ITEMS.NEW_PROJECT,
      CENTRAL_MENU_ITEMS.INSTALLMENT,
      CENTRAL_MENU_ITEMS.UTILIZATION_CERTIFICATE,
      CENTRAL_MENU_ITEMS.OVERALL
    ],
    defaultExpanded: []
  },

  [USER_ROLES.DEPARTMENT]: {
    budget: [
      BUDGET_MENU_ITEMS.DASHBOARD,
      BUDGET_MENU_ITEMS.PROJECT_PLANNING,
      BUDGET_MENU_ITEMS.ONGOING_PROJECTS
    ],
    defaultExpanded: []
  }
};

// =============================================================================
// ROLE-BASED NAVIGATION CONFIGURATIONS
// =============================================================================

export const ROLE_NAV_CONFIG = {
  [USER_ROLES.ADMIN]: {
    primaryColor: 'navigation',
    accentColor: 'navigation-active',
    defaultRoute: '/dashboard',
    homeTitle: 'Admin Dashboard',
    features: ['budget', 'state', 'central']
  },
  [USER_ROLES.PLANNING_OFFICIAL]: {
    primaryColor: 'navigation',
    accentColor: 'navigation-active',
    defaultRoute: '/dashboard',
    homeTitle: 'Planning Dashboard',
    features: ['budget', 'state', 'central']
  },
  [USER_ROLES.DONER]: {
    primaryColor: 'navigation',
    accentColor: 'navigation-active',
    defaultRoute: '/dashboard',
    homeTitle: 'DoNER Dashboard',
    features: ['budget', 'state', 'central']
  },
  [USER_ROLES.DEPARTMENT]: {
    primaryColor: 'navigation',
    accentColor: 'navigation-active', 
    defaultRoute: '/dashboard',
    homeTitle: 'Department Dashboard',
    features: ['budget']
  }
};

// =============================================================================
// HELPER FUNCTIONS
// =============================================================================

export const getMenuItemsForRole = (userRole, tab = 'budget') => {
  const config = ROLE_SIDEBAR_CONFIG[userRole];
  if (!config || !config[tab]) return [];

  return config[tab].map(item => {
    if (item.type === 'single') {
      return item.allowedRoles.includes(userRole) ? item : null;
    } else if (item.type === 'group') {
      const filteredItems = item.items?.filter(subItem => 
        subItem.allowedRoles.includes(userRole)
      ) || [];
      
      if (filteredItems.length > 0 || item.comingSoon) {
        return {
          ...item,
          items: filteredItems
        };
      }
    }
    return null;
  }).filter(Boolean);
};

export const getStateMenuItems = (userRole) => {
  return getMenuItemsForRole(userRole, 'state');
};

export const getCentralMenuItems = (userRole) => {
  return getMenuItemsForRole(userRole, 'central');
};

export const getDefaultExpandedForRole = (userRole) => {
  const config = ROLE_SIDEBAR_CONFIG[userRole];
  return config ? config.defaultExpanded : [];
};

export const hasAccessToMenuItem = (menuItem, userRole) => {
  if (!menuItem || !userRole) return false;
  
  if (menuItem.allowedRoles && Array.isArray(menuItem.allowedRoles)) {
    return menuItem.allowedRoles.includes(userRole);
  }
  
  return false;
};

export const getMenuItemByPath = (userRole, path, tab = 'budget') => {
  const menuItems = getMenuItemsForRole(userRole, tab);
  
  for (const item of menuItems) {
    if (item.type === 'single' && item.path === path) {
      return item;
    }
    
    if (item.type === 'group' && item.items) {
      for (const subItem of item.items) {
        if (subItem.path === path) {
          return subItem;
        }
      }
    }
  }
  
  return null;
};

export const isMenuItemActive = (menuItem, currentPath) => {
  if (!menuItem || !currentPath || menuItem.comingSoon) return false;
  
  return menuItem.path === currentPath;
};

export const getRoleNavStyling = (role) => {
  const config = ROLE_NAV_CONFIG[role] || ROLE_NAV_CONFIG[USER_ROLES.DEPARTMENT];
  
  return {
    primaryColor: config.primaryColor,
    accentColor: config.accentColor
  };
};

export default {
  MENU_ITEMS: BUDGET_MENU_ITEMS,
  ROLE_SIDEBAR_CONFIG,
  ROLE_NAV_CONFIG,
  getMenuItemsForRole,
  getStateMenuItems,
  getCentralMenuItems,
  getDefaultExpandedForRole,
  hasAccessToMenuItem,
  getMenuItemByPath,
  isMenuItemActive,
  getRoleNavStyling
};